export const numberRegexString = '\\d{1,}';

export default function constainsNumber(value: string) {
  const numberRegex = new RegExp(numberRegexString);

  return numberRegex.test(value);
}
